// src/overlayComponents/ModuleBody.js
import React from 'react';
// import { useTheme } from '../overlayUtils/ThemeProvider';
import { useTheme } from '../../themes/ThemeProvider';

const ModuleBody = ({ id, children, endpoints, readyState, activeState, toggleModuleActive }) => {
  const { theme, size } = useTheme();

  return (
    // <div className={`${theme.body} ${sizeClasses[size] || sizeClasses.medium} overflow-auto relative h-full pt-2`}>
    <div className={`${theme.body} overflow-auto relative h-full nopan nowheel nodrag`}>
      {endpoints && endpoints.length > 0 && (
        <div className='absolute flex right-0 top-0 '>
          <span 
            className={`font-mono border-l border-b rounded-bl ${theme.info} px-1 text-[0.6em] cursor-auto`} 
            title={endpoints.map(ep => `${ep.category}:\n   ${ep.path}`).join('\n')}
            >
            I
          </span>
          <span 
            // className={`font-mono border-l border-b px-1 text-[0.6em] cursor-pointer ${readyState ? 'bg-emerald-900 border-emerald-800 text-emerald-300' : 'bg-red-900 border-gray-600 text-gray-300' }`}
            className={`font-mono border-l border-b px-1 text-[0.6em] cursor-pointer hover:text-white hover:font-semibold ${activeState ? 'bg-[#005500] border-gray-500 text-pink-200' : 'bg-red-900 border-gray-600 text-gray-300' }`}
            title={activeState ? 'Active for Execution' : 'Inactive for Execution'}
            onClick={() => {
              toggleModuleActive(id)
            }}
            >
            A
          </span>
          <span 
            // className={`font-mono border-l border-b px-1 text-[0.6em] cursor-pointer ${readyState ? 'bg-emerald-900 border-emerald-800 text-emerald-300' : 'bg-red-900 border-gray-600 text-gray-300' }`}
            className={`font-mono border-l border-b px-1 text-[0.6em] cursor-auto hover:text-white hover:font-semibold ${readyState ? 'bg-[#005500] border-gray-500 text-pink-200' : 'bg-red-900 border-gray-600 text-gray-300' }`}
            title={readyState ? 'READY!' : 'NOT READY!'}
            >
            R
          </span>
        </div>
      )}
      {children}
    </div>
  );
};

export default ModuleBody;